import { Company } from "Company/Domain/Model/Company";
import { Delegation } from "Delegation/Domain/Model/Delegation";
import { JobPosition } from "JobPosition/Domain/Model/JobPosition";
import { ProfessionalCategory } from "ProfessionalCategory/Domain/Model/ProfessionalCategory";
export class User {
  constructor(
    id,
    email,
    name,
    firstSurname,
    secondSurname,
    dni,
    shortName,
    extension,
    personalPhone,
    workPhone,
    hireDate,
    terminationDate,
    birthDate,
    iban,
    enabled,
    roles,
    permissions,
    permissionGroups,
    jobPosition,
    company,
    delegation,
    professionalCategory,
    deletedAt,
    fullName,
    workerId,
    gender,
    isDirectEmployee,
    commissionsCommercialExtras,
    commissionsAnnexes,
    personalDataVerified,
    avatar,
    fcmTokenFirebase,
    receivesMealAllowance,
    enableTravelSigning,
    theoreticalZone,
    expenseIban,
    siebelId
  ) {
    this.id = id;
    this.email = email;
    this.name = name;
    this.firstSurname = firstSurname;
    this.secondSurname = secondSurname;
    this.dni = dni;
    this.shortName = shortName;
    this.extension = extension;
    this.personalPhone = personalPhone;
    this.workPhone = workPhone;
    this.hireDate = hireDate;
    this.terminationDate = terminationDate;
    this.birthDate = birthDate;
    this.iban = iban;
    this.enabled = enabled;
    this.roles = roles;
    this.permissions = permissions;
    this.permissionGroups = permissionGroups;
    this.jobPosition = jobPosition;
    this.company = company;
    this.professionalCategory = professionalCategory;
    this.delegation = delegation;
    this.deletedAt = deletedAt;
    this.fullName = fullName;
    this.workerId = workerId;
    this.gender = gender;
    this.isDirectEmployee = isDirectEmployee;
    this.commissionsCommercialExtras = commissionsCommercialExtras;
    this.commissionsAnnexes = commissionsAnnexes;
    this.personalDataVerified = personalDataVerified;
    this.avatar = avatar;
    this.fcmTokenFirebase = fcmTokenFirebase;
    this.receivesMealAllowance = receivesMealAllowance;
    this.enableTravelSigning = enableTravelSigning;
    this.theoreticalZone = theoreticalZone;
    this.expenseIban = expenseIban;
    this.siebelId = siebelId;
  }
  static createFromResponseData(data) {
    return new User(
      data.id,
      data.email,
      data.name,
      data.firstSurname,
      data.secondSurname,
      data.dni,
      data.shortName,
      data.extension,
      data.personalPhone,
      data.workPhone,
      data.hireDate,
      data.terminationDate,
      data.birthDate,
      data.iban,
      data.enabled,
      data.roles,
      data.permissions,
      data.permissionGroups,
      JobPosition.createFromResponseData?.(data.jobPosition),
      Company.createFromResponseData?.(data.company),
      Delegation.createFromResponseData?.(data.delegation),
      ProfessionalCategory.createFromResponseData?.(data.professionalCategory),
      data.deletedAt,
      data.fullName,
      data.workerId,
      data.gender,
      data.isDirectEmployee,
      data.commissionsCommercialExtras,
      data.commissionsAnnexes,
      data.personalDataVerified,
      data.avatar,
      data.fcmTokenFirebase,
      data.receivesMealAllowance,
      data.enableTravelSigning,
      data.theoreticalZone,
      data.expenseIban,
      data.siebelId
    );
  }
};